import React, { useState } from "react";
import axios from "axios";
import { confirmAlert } from "react-confirm-alert";
import { ToastDismiss, ToastError } from "../functions/ToastShow";
import { useTranslation } from "react-i18next";
import { getCookie } from "../functions/Functions";
import { useCustomHooks } from "../functions/Hooks";
import moment from "moment";
import { BASE_URL } from "../BaseUrl";

export default function useFOCManagerVerify({ loading, setLoading }) {

    const { t } = useTranslation()
    const { getOfflineApiUrl } = useCustomHooks()

    // ----------------------------
    // Submit Request
    // ----------------------------
    const verifyFOCManager = async (form, payload, onClose, onSuccess, setIsVerifying) => {

        const email = form["mangerEmail"].value;
        const password = form["mangerPassword"].value;

        if (!email || !password) {
            ToastDismiss();
            ToastError({ title: t("Manager Email or Password is Required!") });
            return;
        }

        const data = {
            email,
            password,
            dayOpenDate: moment(payload.dayOpenDate, "DD-MM-YYYY").format("YYYY-DD-MM"),
            amount: payload.amount,
        };

        // const url = getOfflineApiUrl("/auth/verify-foc-manager");
        
        const url = BASE_URL+"/auth/verify-foc-manager";

        setIsVerifying(true)

        try {

            if (setLoading) setLoading(true);

            const res = await axios.post(url, data, {
                headers: { Authorization: `Bearer ${getCookie()}` },
            });

            if (setLoading) setLoading(false);
            setIsVerifying(false)


            if (res.data.success) {
                let mangerId = res.data.verified_manager_id
                if (onSuccess) onSuccess(mangerId);
                return
            }

            if (res?.data?.foc_limit || res?.data?.foc_limit == 0) {
                ToastError({ title: `${res?.data?.message} ${t(`is`)} ${res?.data?.foc_limit}` })
            }
            else if (res?.data?.message) {
                ToastError({ title: res?.data?.message });
            }


            onClose();


        } catch (err) {
            if (setLoading) setLoading(false);
            onClose();
            setIsVerifying(false)

            const msg = err?.response?.data?.message || t("Please try again");
            ToastError({ title: msg });

        }
    };

    function FOCManagerModal({ onClose, onSubmit, t }) {
        const [isVerifying, setIsVerifying] = useState(false);

        const modalStyle = {
            minWidth: "450px",
            maxWidth: "500px",
            borderRadius: "12px",
            boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.15)",
            border: "none",
            padding: "2rem"
        };

        const headerStyle = {
            marginBottom: "1.5rem",
            fontSize: "1.5rem",
            fontWeight: "600",
            color: "#2c3e50"
        };

        const labelStyle = {
            fontWeight: "500",
            fontSize: "0.95rem",
            color: "#495057",
            marginBottom: "0.5rem"
        };

        const inputStyle = {
            borderRadius: "8px",
            padding: "0.65rem 0.75rem",
            fontSize: "0.95rem",
            border: "1px solid #ced4da",
            transition: "all 0.2s ease"
        };

        const buttonContainerStyle = {
            marginTop: "1.75rem",
            gap: "0.75rem"
        };

        const verifyButtonStyle = {
            minWidth: "120px",
            padding: "0.5rem 1.2rem",
            fontSize: "0.8rem",
            fontWeight: "500",
            borderRadius: "8px",
        };

        const cancelButtonStyle = {
            minWidth: "100px",
            padding: "0.5rem 1.2rem",
            fontSize: "0.8rem",
            fontWeight: "500",
            borderRadius: "8px",
        };

        return (
            <div className="card card-body" style={modalStyle}>
                <h4 className="text-center" style={headerStyle}>
                    {t("FOC Verify by Manager")}
                </h4>

                <form autoComplete="off" onSubmit={(e) => onSubmit(e, setIsVerifying)}>

                    <div className="form-group mb-3">
                        <label style={labelStyle}>
                            {t("Manager Email")}
                        </label>
                        <input
                            type="email"
                            className="form-control"
                            name="mangerEmail"
                            autocomplete="off"
                            placeholder="manager@example.com"
                            style={inputStyle}
                            required
                        />
                    </div>

                    <div className="form-group mb-3">
                        <label style={labelStyle}>
                            {t("Manager Password")}
                        </label>
                        <input
                            type="password"
                            className="form-control"
                            name="mangerPassword"
                            autoComplete="new-password"
                            placeholder="••••••••"
                            style={inputStyle}
                            required
                        />
                    </div>

                    <div className="d-flex justify-content-center" style={buttonContainerStyle}>
                        <button
                            className="btn btn-primary"
                            type="submit"
                            disabled={isVerifying}
                            style={verifyButtonStyle}
                        >
                            {isVerifying ? (
                                <>
                                    <span className="spinner-border spinner-border-sm mr-2"></span>
                                    {t("Verifying...")}
                                </>
                            ) : (
                                t("Verify")
                            )}
                        </button>

                        <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={onClose}
                            disabled={isVerifying}
                            style={cancelButtonStyle}
                        >
                            {t("Cancel")}
                        </button>
                    </div>

                </form>
            </div>
        );
    }

    // ----------------------------
    // Open Modal
    // ----------------------------
    const openFOCManagerModal = (payload, onSuccess) => {
        confirmAlert({
            customUI: ({ onClose }) => (
                <FOCManagerModal
                    onClose={onClose}
                    t={t}
                    onSubmit={(e, setIsVerifying) => {
                        e.preventDefault();
                        verifyFOCManager(e.target, payload, onClose, onSuccess, setIsVerifying);
                    }}
                />
            )
        });
    };



    return {
        openFOCManagerModal
    };
}
